import { render, staticRenderFns } from "./AsiChip.vue?vue&type=template&id=15a216a5&scoped=true"
import script from "./AsiChip.vue?vue&type=script&lang=ts"
export * from "./AsiChip.vue?vue&type=script&lang=ts"
import style0 from "./AsiChip.vue?vue&type=style&index=0&id=15a216a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a216a5",
  null
  
)

export default component.exports